import { getFeatureFlag } from '@root/helpers/feature-flags';
import { isPPLFrontend } from '@root/src/utils/app-paths';

import EntraSaveCloseButton from './EntraSaveCloseButton';

const getSaveCloseButton = () => {
  if (isPPLFrontend ? getFeatureFlag('SaveClose') : false) {
    return EntraSaveCloseButton;
  }

  return () => {
    return null;
  };
};

const SaveCloseButton = getSaveCloseButton();
export default SaveCloseButton;
